export namespace FdpDetailsSideNavigation {
  export const SIDE_NAVIGATION_OPTION_LABEL = {
    FDP_SUBMISSION: 'FDP Submission',
    POSITION_PAPER: 'Position Paper',
    ATTACHMENTS: 'Attachments',
    ACTIVITY_LOGS: 'Activity Logs',
  };

  export type SideNavigationOption = {
    label: string;
    link: string;
    iconName: string;
    isDisabled: boolean;
  };

  export type SideNavigationOptions = SideNavigationOption[];
}
